<template>
<div>
    <vue-headful :title="title" />
    <md-card-header class="md-card-header-icon" :class="color || 'md-card-header-site'">
        <div class="md-layout">
            <div class="card-icon">
                <h4 class="title page-title">{{ title }}</h4>
            </div>
            
            <slot />

            <div v-if="!btnHide" class="btn-title">
                <md-button :to="rota" class="md-site md-just-icon md-round">
                    <i :class="icon || 'fas fa-list'"></i>
                    <md-tooltip md-direction="top">{{ tooltip }}</md-tooltip>
                </md-button>
            </div>
        </div>
    </md-card-header>
</div>
</template>

<script>
export default {
    props: ['title', 'rota', 'tooltip', 'icon', 'btnHide', 'color']
}
</script>

<style>
</style>
